import * as React from 'react';
import SkillFileComponent from './SkillFileComponent';
import { AiAgentV2Data, SkillType } from '../../../../../types/AiAgentV2';
import RenderFormFieldsComponent, {
    GroupTypes,
} from '../../../../shared/renderFormFieldsComponent/RenderFormFieldsComponent';
import { FileProps } from '../../../../shared/DragAndDrop';
import { Control, UseFormRegister, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { SkillForm } from './AgentSkillsComponent';
import SheetComponent from '../../../../shared/sheetComponent/SheetComponent';
import { useTranslate } from 'sbx-crm-menu-ui';


type Props = {
    setValue: UseFormSetValue<SkillForm>
    watch: UseFormWatch<SkillForm>
    control: Control<SkillForm>
    register: UseFormRegister<SkillForm>
    skillsField: GroupTypes<keyof AiAgentV2Data>
    skillRetrieverFields: GroupTypes<keyof AiAgentV2Data>
    deleteFileFolder: (props: { file: FileProps, name: string }) => void
}

const SkillSummarizeConfig = ({
                                  watch,
                                  setValue,
                                  control,
                                  // register,
                                  deleteFileFolder,
                                  skillsField,
                                  // skillRetrieverFields,
                              }: Props) => {

    const { t: agent } = useTranslate('agent');


    return (

        <div>
            <SheetComponent buttonLabel={agent('summarize_config')}
                            title={agent('summarize_config')}
                            titleClassName={'font-bold text-purple-800'}
                            buttonClassName={'bg-gradient-to-r from-pink-500 to-purple-600 hover:from-pink-600 hover:to-purple-700 text-white font-semibold py-2 px-6 rounded-full transition-all duration-300 transform hover:scale-105'}
                            contentClassName="bg-gradient-to-br from-purple-50 to-pink-50 w-full !max-w-[100vw] xl:w-[55vw] xl:max-w-[55vw] xxl:max-w-[45vw] xxl:w-[45vw] lg:w-[55vw] lg:max-w-[55vw] ">

                <div className={`grid grid-cols-1 gap-3 mb-3 max-h-[80vh] overflow-auto`}>

                    <SkillFileComponent setFiles={
                        files => setValue('new_skill.config.summarize_config.files', files)
                    } files={watch('new_skill.config.summarize_config.files') ?? []}
                                        filesComponent={watch('new_skill.config.summarize_config.filesComponent') ?? []}
                                        setFilesComponent={
                                            files => setValue('new_skill.config.summarize_config.filesComponent', files)
                                        }
                                        deleteFile={file => deleteFileFolder({
                                            file,
                                            name: 'config.summarize_config',
                                        })} />

                    <div
                        className={`grid ${skillsField[SkillType.SkillSummarize].columns ?? 'grid-cols-1 '} gap-3 mb-3`}>
                        <RenderFormFieldsComponent
                            fields={skillsField[SkillType.SkillSummarize].items.map(item => {
                                const name = item.name.split('.').at(-1);
                                return {
                                    ...item,
                                    name: `new_skill.config.summarize_config.${name}`,
                                };
                            })}
                            control={control}
                        />
                    </div>

                    {/*<SkillActionRetrieverComponent*/}
                    {/*    control={control}*/}
                    {/*    parentConfig={'summarize_config.action_retriever_config'}*/}
                    {/*    customRetrieverFields={name => <SkillCustomRetrieverFields*/}
                    {/*        name={'config.summarize_config.action_retriever_config'}*/}
                    {/*        setFilesComponent={files => {*/}
                    {/*            setValue(`new_skill.config.summarize_config.action_retriever_config.filesComponent`, files);*/}
                    {/*        }}*/}
                    {/*        setFiles={files => {*/}
                    {/*            setValue(`new_skill.config.summarize_config.action_retriever_config.files`, files);*/}
                    {/*        }}*/}
                    {/*        files={watch(`new_skill.config.summarize_config.action_retriever_config.files`) ?? []}*/}
                    {/*        filesComponent={(watch(`new_skill.config.summarize_config.action_retriever_config.filesComponent`) ?? []) as FileProps[]}*/}
                    {/*        control={control}*/}
                    {/*        watch={watch}*/}
                    {/*        deleteFile={file => deleteFileFolder({ file, name })}*/}
                    {/*    />}*/}

                    {/*    register={register}*/}
                    {/*    skillRetrieverFields={skillRetrieverFields}*/}
                    {/*/>*/}

                </div>
            </SheetComponent>
        </div>


    );
};

export default SkillSummarizeConfig;